import * as React from "react";
import { InjectedIntlProps, injectIntl } from "react-intl";

import { Button, InputNumber, Skeleton } from "antd";
import { CoverMeasurementLifecycle, NodeStatus, PropagationLevel } from "../../store/projects/types";
import { IRowEntry, skeletonProps } from "./covermeasurements";

interface IOwnProps {
    record: IRowEntry;
    copy: boolean;
    isEditingThreshold: (record: IRowEntry) => boolean;
    saveThresholdChange: (newThreshold: number | undefined, key: string) => void;
    editThreshold: (record: IRowEntry) => void;
    cancelThresholdChange: () => void;
}

type AllProps = IOwnProps & InjectedIntlProps;

interface IState {
    currentTreshold?: number;
}

class CovermeasurementThreshold extends React.PureComponent<AllProps, IState> {
    constructor(props: AllProps) {
        super(props);
        this.state = {
            currentTreshold: props.record.propagatedThreshold.value
        };
    }

    onTresholdChanged(value: number | undefined) {
        this.setState({
            ...this.state,
            currentTreshold: value
        });
    }

    render() {
        const {
            record,
            copy,
            isEditingThreshold,
            saveThresholdChange,
            cancelThresholdChange,
            editThreshold
        } = this.props;

        if (record.status === CoverMeasurementLifecycle.Draft) {
            return <Skeleton {...skeletonProps} />;
        } else if (record.status === CoverMeasurementLifecycle.Error) {
            return "—";
        } else {
            let thresholdString: string;
            let textStyle: any = { float: "left", color: "#bbb" };

            if (record.threshold) {
                thresholdString = record.threshold.toString();
                textStyle = { float: "left" };
            } else {
                switch (record.propagatedThreshold.sourceLevel) {
                    case PropagationLevel.PROJECT:
                        thresholdString = `${record.propagatedThreshold.value} (${this.props.intl.formatMessage({
                            id: "project"
                        })})`;
                        break;
                    case PropagationLevel.NODE:
                        thresholdString = `${record.propagatedThreshold.value} (${
                            record.propagatedThreshold.sourceName
                        })`;
                        break;
                    case PropagationLevel.FILE:
                        thresholdString = `${record.propagatedThreshold.value}`;
                        textStyle = { float: "left" };
                        break;
                    default:
                        thresholdString = "";
                }
            }

            if (copy) {
                return (
                    <span>
                        <div style={textStyle}>{thresholdString}</div>
                    </span>
                );
            } else if (isEditingThreshold(record)) {
                return (
                    <span>
                        <InputNumber
                            min={0}
                            defaultValue={this.state.currentTreshold}
                            onChange={this.onTresholdChanged.bind(this)}
                            value={this.state.currentTreshold}
                            placeholder={thresholdString}
                            onKeyUp={e => {
                                if (e.key === "Enter") {
                                    saveThresholdChange(this.state.currentTreshold, record.key);
                                }
                            }}
                            autoFocus={true}
                            onFocus={e => e.target.select()}
                        />
                        <Button
                            size="small"
                            icon="check"
                            onClick={e => {
                                saveThresholdChange(this.state.currentTreshold, record.key);
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            style={{ border: "none", backgroundColor: "rgba(0, 0, 0, 0)" }}
                        />
                        <Button
                            size="small"
                            icon="close"
                            onClick={e => {
                                cancelThresholdChange();
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            style={{ border: "none", backgroundColor: "rgba(0, 0, 0, 0)" }}
                        />
                    </span>
                );
            } else {
                return (
                    <span>
                        {record.nodeStatus !== NodeStatus.DISABLED && (
                            <Button
                                size="small"
                                icon="edit"
                                onClick={() => editThreshold(record)}
                                style={{
                                    float: "left",
                                    marginLeft: 2,
                                    border: "none",
                                    backgroundColor: "rgba(0, 0, 0, 0)"
                                }}
                            />
                        )}
                        <div style={textStyle}>{thresholdString}</div>
                    </span>
                );
            }
        }
    }
}

export default injectIntl(CovermeasurementThreshold);
